import VideoJsAdapter from "@javascripts/adapters/videojs_adapter";
import Button from "../button";

export default class Index extends Button {

  constructor(player, options = {}){
    super(player, options);

    this.data_ = options.data;
    this.ads_ = options.ads;
    this.tech_ = options.tech;
    this.autoplay_ = options.autoplay;
    this._isHidden = false;
    this.triggerEvent('vp-unmute-button-load-event');
    this.bindVolumeChangeEvent();
  }

  buildCSSClass() {
    return 'vjs-unmute-button';
  }

  data(){
    return this.data_;
  }

  ads(){
    return this.ads_;
  }

  tech() {
    return this.tech_;
  }

  autoplay(){
    return this.autoplay_;
  }

  isHidden() {
    return this._isHidden;
  }

  triggerEvent(eventType){
    this.player().trigger({
      type: eventType,
      embed: this.data().embed(),
      id: this.data().videoId(),
      videoDuration: this.data().videoDuration(),
      hasAd: this.ads().paramsPresent(),
      autoplay: this.autoplay()
    });
  }

  handleClick(){
    this.triggerEvent('vp-unmute-button-click-event');

    this.player().muted(false);

    this.hide();
  }

  bindVolumeChangeEvent() {
    const player = this.player();

    player.on("volumechange", () => {
      if (player.muted()) return;
      if (this.isHidden()) return;

      this._isHidden = true;
      this.hide();
    });
  }
}

Index.prototype.controlText_ = "Tap to unmute";
VideoJsAdapter.registerComponent('VpUnmuteButton', Index);
